import { create } from 'zustand'
import type { Profile } from '@/services/profileService'

// สรุปโปรไฟล์ที่ Navbar ใช้โชว์ (ชื่อ/อีเมล/รูป) — แชร์กับหน้า "โปรไฟล์ของฉัน"
// ไม่งั้น Navbar ดึงโปรไฟล์ครั้งเดียวตอนล็อกอิน แก้ชื่อหรือเปลี่ยนรูปแล้วมุมขวาบนยังเป็นข้อมูลเก่า
export interface ProfileSummary {
  name: string
  email: string
  imageUrl: string | null   // รูปโปรไฟล์ของบุคคล (avatar_url) หรือโลโก้ของบริษัท (logo_url)
}

interface ProfileState {
  summary: ProfileSummary | null
  setFromProfile: (p: Profile) => void
  clear: () => void
}

export const toProfileSummary = (p: Profile): ProfileSummary =>
  'first_name' in p
    ? { name: `${p.first_name} ${p.last_name}`, email: p.email, imageUrl: p.avatar_url || null }
    : { name: p.company_name, email: p.email, imageUrl: p.logo_url || null }

export const useProfileStore = create<ProfileState>((set) => ({
  summary: null,
  setFromProfile: (p) => set({ summary: toProfileSummary(p) }),
  clear: () => set({ summary: null }),
}))
